import { api as r } from "../utils/configuration.js";
import { crudService as i } from "../js/request-DH6Y2P3c.js";
const c = {
  search: (e) => i.get(r.AMENITY_TYPES_URL, { signal: e })
};
export {
  c as AmenityTypesService
};
//# sourceMappingURL=amenity-types.js.map
